/**
 * Get the correct backend API URL based on the current environment
 * 
 * - Production (.plateos.io domain): Uses https://api.plateos.io
 * - Preview/Development: Uses REACT_APP_BACKEND_URL from .env
 * 
 * @returns {string} The backend API URL
 */
export const getBackendUrl = () => {
  const hostname = window.location.hostname;
  
  // Production environment check
  if (hostname.includes('.plateos.io')) {
    return 'https://api.plateos.io';
  }
  
  // Preview/Development environment
  return process.env.REACT_APP_BACKEND_URL || '';
};

/**
 * Get tenant subdomain from current URL
 * 
 * @returns {string|null} The tenant subdomain or null
 */
export const getTenantSubdomain = () => {
  const hostname = window.location.hostname;
  
  // Check for URL parameter (for localhost testing)
  const searchParams = new URLSearchParams(window.location.search);
  const tenantParam = searchParams.get('tenant');
  if (tenantParam) {
    return tenantParam;
  }
  
  // Skip localhost and main domain
  if (hostname === 'localhost' || hostname === 'plateos.io' || hostname === 'www.plateos.io') {
    return null;
  }
  
  // Extract subdomain from hostname (e.g., tenant.plateos.io -> tenant)
  const parts = hostname.split('.');
  if (parts.length >= 2) {
    const sub = parts[0];
    // "api" is the API endpoint, not a tenant
    if (sub === 'api') return null;
    return sub;
  }
  
  return null;
};
